export default __webpack_public_path__ + "static/media/Guru-Parampara-36.537ac238.png";